import Vue from 'vue'
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import moment from 'moment';
import _ from "lodash";
import ifvisible from "ifvisible.js";
import AsyncComputed from 'vue-async-computed';
import InputFacade from 'vue-input-facade';

import { EventBus } from './event-bus';
import system from './services/system';
import notifier from './plugins/notifier';
import VueApexCharts from 'vue-apexcharts';
import helpers from './plugins/helper-functions';
import ComponentMapper from './plugins/component-mapper';
import PermissionsHelper from './plugins/permissions-helper';

import { httpAPI } from '@/api/httpAPI';

document.title = process.env.VUE_APP_TITLE || 'СЭД «ИНТЕГРО»';

//это нужно чтоб избавится от ошибки в консоли TouchEvent is not defined в браузере FireFox при наведение на полоску диаграммы ганта в компоненте ejs-gantt
if (typeof window !== 'undefined' && !window.TouchEvent) {
    window.TouchEvent = class TouchEvent extends MouseEvent {
      constructor(type, eventInitDict) {
        super(type, eventInitDict);
        this.touches = eventInitDict?.touches || [];
        this.targetTouches = this.touches;
        this.changedTouches = this.touches;
      }
    };
  }

Vue.prototype.$moment = moment;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$_ = _;
Vue.prototype.$ifvisible = ifvisible;
Vue.prototype.$system = system;
/*число видимых кнопок в пагинации на списках разделов*/
Vue.prototype.$listPaginationTotal = 10;
Vue.config.productionTip = false;

Vue.prototype.$refLocale = (refItem, i18nlocale) => {
    let uniLocale;

    switch(i18nlocale)
    {
        case 'ru':
            uniLocale = 'ru-RU';
            break;

        default:
            uniLocale = 'kk-KZ';
            break;
    }
    
    if (Object.prototype.hasOwnProperty.call(refItem, 'UniValue') && refItem.UniValue) {
        return refItem.UniValue[uniLocale] // если в объекте UniValue есть свойство с именем uniLocale и оно не falsy (undefined, null, empty, e.t.c)
            ? refItem.UniValue[uniLocale] // возвращаем его
            : refItem.UniValue['ru-RU'] // в противном случае проверяем свойство ru-RU и если оно не falsy (undefined, null, empty, e.t.c)
                ? refItem.UniValue['ru-RU'] // возвращаем его
                : refItem.Value; // в противном случае возвращаем свойство Value
    }

    return refItem.Value;
};

Vue.prototype.$refTruncateFilename = (filename, charsToKeep = 5) => {
    if (!filename || typeof filename !== 'string') {
        return '';
    }
    const separator = '...';
    const minLengthForTruncate = charsToKeep * 2 + separator.length;
    const lastDotIndex = filename.lastIndexOf('.');
    let name = filename;
    let extension = '';
    if (lastDotIndex > 0) {
        name = filename.substring(0, lastDotIndex);
        extension = filename.substring(lastDotIndex);
    }
    if (name.length <= minLengthForTruncate) {
        return filename;
    }
    const start = name.substring(0, charsToKeep);
    const end = name.substring(name.length - charsToKeep);
    return start + separator + end + extension;
};

Vue.use(AsyncComputed, {
    errorHandler (stack) {
        console.log('AsyncComputed error!')
        console.log('---')
        console.log(stack)
    }
});
Vue.use(PermissionsHelper, store);
Vue.use(VueApexCharts)

Vue.use(InputFacade)

Vue.component('apexchart', VueApexCharts)

Vue.component(`v-doc-type-chip`, () => import('@/components/documents/chips/v-doc-type-chip.vue'));
Vue.component(`v-doc-chip`, () => import('@/components/documents/chips/v-doc-chip.vue'));
Vue.component(`history-tab`, () => import('@/components/documents/tabs/history.vue'));
Vue.component(`linkeddocs-tab`, () => import('@/components/documents/tabs/linkeddocs.vue'));
Vue.component(`signs-tab`, () => import('@/components/documents/tabs/signs.vue'));
Vue.component(`notifications-tab`, () => import('@/components/documents/tabs/notifications.vue'));
Vue.component(`adjustments-tab`, () => import('@/components/documents/tabs/adjustments.vue'));
Vue.component(`euol-versions-tab`, () => import('@/components/documents/tabs/euolversions.vue'));
Vue.component(`v-document-link`, () => import('@/components/documents/DocumentLink.vue'));

Vue.component(`v-card-panel`, () => import('@/components/global/card/v-card-panel.vue'));
Vue.component(`v-field`, () => import('@/components/global/card/v-field.vue'));
Vue.component(`v-field-edit-bool`, () => import('@/components/global/card/v-field-edit-bool.vue'));
Vue.component(`v-field-edit-text`, () => import('@/components/global/card/v-field-edit-text.vue'));
Vue.component(`v-field-edit-date`, () => import('@/components/global/card/v-field-edit-date.vue'));
Vue.component(`v-field-edit-number`, () => import('@/components/global/card/v-field-edit-number.vue'));
Vue.component(`v-field-edit-select`, () => import('@/components/global/card/v-field-edit-select.vue'));
Vue.component(`v-label`, () => import('@/components/global/card/v-label.vue'));
Vue.component(`v-attachment-item`, () => import('@/components/global/card/v-attachment-item.vue'));
Vue.component(`v-field-readonly`, () => import('@/components/global/card/v-field-readonly.vue'));

Vue.component(`v-execution-tree`, () => import('@/components/global/card/v-execution-tree.vue'));
Vue.component(`v-select-members-chip`, () => import('@/components/global/chips/SelectMembersChip.vue'));
Vue.component(`v-contact-item`, () => import('@/components/global/chips/v-contact-item.vue'));
Vue.component(`v-file-item`, () => import('@/components/global/chips/v-file-item.vue'));
Vue.component(`v-workplace-chip`, () => import('@/components/global/chips/v-workplace-chip.vue'));
Vue.component(`v-email-chip`, () => import('@/components/global/chips/v-email-chip.vue'));
Vue.component(`v-employee-chip`, () => import('@/components/global/chips/v-employee-chip.vue'));
Vue.component(`v-enterprise-chip`, () => import('@/components/global/chips/v-enterprise-chip.vue'));
Vue.component(`v-common-chip`, () => import('@/components/global/chips/CommonDocumentChip.vue'));
Vue.component(`v-tag-chip`, () => import('@/components/global/chips/v-tag-chip.vue'));

Vue.component(`attachments-tab`, () => import('@/components/global/tabs/attachments.vue'));
Vue.component(`resolutions-tab`, () => import('@/components/global/tabs/resolutions.vue'));
Vue.component(`comments-tab`, () => import('@/components/global/tabs/comments-tab.vue'));
Vue.component(`comments-event-tab`, () => import('@/components/global/tabs/comments-event-tab.vue'));
Vue.component(`actitems-tab`, () => import('@/components/global/tabs/actitems.vue'));
Vue.component(`routes-tab`, () => import('@/components/global/tabs/routes.vue'));
Vue.component(`prolongaterequests-tab`, () => import('@/components/global/tabs/prolongaterequests.vue'));
Vue.component(`takenotelist-tab`, () => import('@/components/global/tabs/takenotelist.vue'));

Vue.component(`report-interaction-tab`, () => import('@/components/reportsgeneration/tabs/report-interaction-tab.vue'));

Vue.component(`v-doc-version-chip`, () => import('@/components/documents/DocVersionChip.vue'));

Vue.component(`iqala-comments-tab`, () => import('@/components/qala-qyzmet/tabs/iqalacomments.vue'));

function init() {
    return new Promise(resolve => {
        httpAPI({ url: 'api/security/disabled-modules', method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((response) => store.commit('SET_DISABLED_MODULES', response?.data?.Payload ?? []));

        if (localStorage.getItem("app-uies"))
            store.dispatch('global/auth/restoreAuthorize', JSON.parse(Buffer.from(localStorage.getItem("app-uies"), 'base64').toString()) , { root: true });

        resolve();
    });
}

init().then(() => {
    new Vue({
        router,
        store,
        vuetify,
        i18n,
        render: h => h(App),
        created() {
            document.documentElement.lang = this.$i18n.locale
            //региструем плагин и передаем в него хранилище нашего инстанса Vue
            Vue.use(notifier, i18n);
            Vue.use(helpers);
            Vue.use(ComponentMapper);
        },
        watch: {
            '$i18n.locale'(newLang) {
                document.documentElement.lang = newLang
            }
        }
    }).$mount('#app') 
});